import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { HisCoreSharedModule } from '../core/his-core-shared.module';
import { HisInputCoreModule } from '../input/his-input-core.module';
import { HisStructureSharedModule } from '../structure/his-structure-shared.module';
import { CommunicationLogEntriesComponent } from './component/communication-log-entries/communication-log-entries.component';
import { CommunicationLogFilterComponent } from './component/communication-log-filter/communication-log-filter.component';
import { HisCommunicationlogComponent } from './component/communicationlog.component';
import { ConversationRecordEditComponent } from './component/conversation-record-edit/conversation-record-edit.component';
import { ChipModule } from 'primeng/chip';
import {AccordionModule} from 'primeng/accordion';
import { CommunicationLogEntryComponent } from './component/communication-log-entry/communication-log-entry.component';

/**
 * SharedModule for Communicationlog.
 */
@NgModule( {
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AutoCompleteModule,
        CalendarModule,
        InputNumberModule,
        PanelModule,
        TableModule,
        TabsModule,
        DialogModule,
        ConfirmDialogModule,
        HisCoreSharedModule,
        HisStructureSharedModule,
        HisInputCoreModule,
        ChipModule,
        AccordionModule,
    ],

    declarations: [
        HisCommunicationlogComponent,
        CommunicationLogFilterComponent,
        CommunicationLogEntriesComponent,
        CommunicationLogEntryComponent,
        ConversationRecordEditComponent
    ],

    exports: [
        HisCommunicationlogComponent
    ]
} )
export class HisCommunicationlogSharedModule {
}
